import React from "react";
import UploadDocumentScreen from "..";
import UploadDocumentContext from "../../../../../context/UploadDocument.context";
import {
  ICreateAndUpdateCompany,
  IUploadDocumentCompany,
} from "../../../../../types/company.interface";
import api from "../../../../../api";
import utils from "../../../../../utils";

// import {useQuery} from "react-query";
// import {TransactionContext} from "../../../../../context";

// type TModal = "SHOW" | "NONE" | "SETUP_ORDER";

const UploadDocumentContainer = () => {
  // ** ==============================================================================================================
  // **                                         Values Validations
  // ** ==============================================================================================================

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  // !! ==============================================================================================================
  // !!                                           Start API Call
  // !! ==============================================================================================================

  async function submitUploadDocument(formData: IUploadDocumentCompany) {
    setIsLoading(true);
    const result = await api.put.common.uploadCompanyDocument(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
    }
    setIsLoading(false);
    return false;
  } // !! ==============================================================================================================
  // !!                                            End API Call
  // !! ==============================================================================================================

  // ?? ==============================================================================================================
  // ??                                            JSX Container
  // ?? ==============================================================================================================

  return (
    <UploadDocumentContext.Provider
      value={{ submitUploadDocument, isLoading, setIsLoading }}
    >
      <UploadDocumentScreen />
    </UploadDocumentContext.Provider>
  );
};

export default UploadDocumentContainer;
